/*
 @flow
 @format
*/

import * as React from 'react';
// import moment from 'moment';
import moment from 'moment-timezone';

import 'moment/locale/es';
import DatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker';
import type { Match } from 'react-router-dom';
import es from 'date-fns/locale/es';

import 'react-datepicker/dist/react-datepicker.css';

import { apiPost } from '../services/api';

import logo from '../assets/logo.png';
import { SUPPORT_PHONE, SUPPORT_EMAIL, DEFAULT_LOCALE } from '../config';

import 'react-activity/lib/Bounce/Bounce.css';

registerLocale('es', es);
moment.locale('es-ES');

const DECISSION_CONFIRM = 1;
const DECISSION_REJECT = 2;
const DECISSION_RESCHEDULE = 4;

type Props = {
  match: Match,
};

type Attendant = {
  name: string,
  email: string,
  status: number,
};

type State = {
  sessionData: null | {
    status: number,
    attendant: Attendant,
    scheduledDatetime: number,
    duration: number,
    proyectoID:string,
  },
  proyectoData : null | {
    proyectoID:string,
    proyectoName:string,
    email:string,
    phone:string,
    image:Object,
    proyectoPublicId:string,
    gmt:string
  },
  showCalendar: boolean,
  statusWasJustChangedNow: boolean,
  rescheduleSelectedValue: number,
};

const ConfirmSessionComponent = ({
  scheduledDatetime,
  duration,
  otherParticipant,
  handleClick,
}: {
  scheduledDatetime: number,
  duration: number,
  otherParticipant: { name: string },
  handleClick: (newStatus: number) => void,
}) => {
  return (
    <>
      <h3>Confirmar sesión.</h3>
      Tiene la siguiente sesión de videollamada programada:
      <SessionInfo
        scheduledDatetime={scheduledDatetime}
        duration={duration}
        otherParticipant={otherParticipant}
      >
        <div className="card-header" style={{ fontWeight: 'bold' }}>
          Por favor, realice alguna de las siguientes acciones:
        </div>
        <ul className="list-group list-group-flush">
          <li className="list-group-item">
            <button
              type="button"
              className="btn btn-success btn-lg"
              style={{ marginBottom: 20 }}
              onClick={() => handleClick(DECISSION_CONFIRM)}
            >
              Confirmar sesión
            </button>
            <p />
            <button
              type="button"
              className="btn btn-danger"
              onClick={() => handleClick(DECISSION_REJECT)}
            >
              Rechazar sesión
            </button>
            <button
              type="button"
              className="btn btn-outline-secondary"
              style={{ marginLeft: 20 }}
              onClick={() => handleClick(DECISSION_RESCHEDULE)}
            >
              Solicitar un cambio de fecha/hora
            </button>
          </li>
        </ul>
      </SessionInfo>
    </>
  );
};

const SessionInfo = ({
  scheduledDatetime,
  duration,
  otherParticipant,
  children,
}: {
  scheduledDatetime: number,
  duration: number,
  otherParticipant: { name: string },
} & React.ElementConfig<any>) => {
  return (
    <div
      className="card"
      style={{
        width: '60vw',
        marginLeft: 'auto',
        marginRight: 'auto',
        marginTop: 20,
        marginBottom: 20,
      }}
    >
      <div className="card-header" style={{ textTransform: 'uppercase' }}>
        Videollamada con <b>{otherParticipant.name}</b>.
      </div>
      <ul style={{ textAlign: 'left' }} className="list-group list-group-flush">
        <li className="list-group-item">
          Fecha: <b>{scheduledDatetime}</b>
        </li>
        <li className="list-group-item">
          Duración aproximada: <b>{duration / 60} minutos</b>
        </li>
      </ul>

      {children}
    </div>
  );
};
const RescheduleComponent = ({
  scheduledDatetime,
  duration,
  otherParticipant,
  onChange,
  onConfirm,
  onCancel,
  value,
}: {
  scheduledDatetime: number,
  duration: number,
  otherParticipant: { name: string },
  onConfirm: (newTS: number) => void,
  onCancel: () => void,
  value: string | null,
}) => {
  return (
    <>
      <h3>Confirmar sesión.</h3>
      Tiene la siguiente sesión de videollamada programada:
      <SessionInfo
        scheduledDatetime={scheduledDatetime}
        duration={duration}
        otherParticipant={otherParticipant}
      />
      <h5 style={{ marginBottom: 20 }}>
        Por favor, seleccione la fecha y hora que desea proponer para esta videollamada:
      </h5>
      <DatePicker
        selected={value}
        onChange={onChange}
        showTimeSelect
        inline
        locale={es}
        timeFormat="p"
        timeIntervals={15}
        dateFormat="Pp"
      />
      <button
        type="button"
        className="btn btn-success btn-lg"
        style={{ marginBottom: 20 }}
        onClick={onConfirm}
      >
        Solicitar cambio de fecha y hora
      </button>
      <p />
      <button type="button" className="btn btn-danger" onClick={onCancel}>
        Volver atrás
      </button>
    </>
  );
};

class SessionChangeStatus extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      sessionData: null,
      proyectoData:null,
      statusWasJustChangedNow: false,
      showCalendar: false,
      rescheduleSelectedValue: null,
    };
    this.handleClick = this.handleClick.bind(this);
  }

  async handleClick(newStatus: number) {
    const {
      match: {
        params: { sessionId, token },
      },
    } = this.props;

    if (newStatus === DECISSION_RESCHEDULE) {
      this.setState({ showCalendar: true });
    } else {
      const changeStatusRequest = await apiPost(`changeStatus`, {
        sessionId,
        token,
        newStatus,
      });

      if (changeStatusRequest === true) {
        this.setState(st => ({
          ...st,
          statusWasJustChangedNow: true,
          sessionData: { ...st.sessionData, status: newStatus },
          proyectoData: { ...st.proyectoData, status: newStatus },
        }));
      } else {
        alert(
          'Error interno tratando de cambiar estado de la sesión. Por favor contacte con soporte si el problema perisste.'
        );
      }
    }
  }

  async componentDidMount() {
    const {
      match: {
        params: { sessionId, token },
      },
    } = this.props;

    const sessionData = await apiPost(`getSessionData`, {
      session: sessionId,
      token,
    });
    console.log(sessionData);
    const proyectoData = await apiPost(`getProyectoData`, {
      proyectoID : sessionData.proyectoID,
    });

    this.setState({ sessionData, proyectoData });
  }

  /*
<div
  id="loading"
  style={{ padding: '20px', display: this.state.isLoading === true ? 'block' : 'none' }}
>
  <span style={{ marginBottom: '20px', display: 'block' }}>
    Cargando sesión, por favor, espere unos instantes...
  </span>
  <Bounce size={30} />
</div>
*/
  render() {
    const { proyectoData, sessionData, statusWasJustChangedNow } = this.state;

    if (!sessionData) {
      return null;
    }

    const {
      attendant: { status },
      scheduledDatetime,
      sessionDuration,
    } = sessionData;
    const {
      phone,
      email,
    } = proyectoData;
    return (
      <div>
        <header className="App-header">
          <img src={logo} style={{ height: '70px', padding: '10px', float: 'left' }} alt="logo"/>
          <h3 style={{ display: 'block', float: 'left', marginLeft: '10px' }}>
            Confirmar sesión de videollamada.
          </h3>
        </header>

        <div
          id="wrapper"
          style={{
            width: '70vw',
            marginLeft: 'auto',
            marginRight: 'auto',
            overflow: 'hidden',
            marginTop: 20,
          }}
        >
          {!statusWasJustChangedNow && (status === 1 || status === 2) && (
            <div className="alert alert-danger" role="alert">
              <b>Esta sesión ya ha sido {status === 1 ? 'aceptada' : 'rechazada'}.</b>
              <br /> Si quiere realizar algún cambio o tiene cualquier consulta, por favor, contacte
              con nosotros llamándonos al {phone} o enviándonos un e-mail a {email}{' '}
            </div>
          )}

          {!statusWasJustChangedNow && status === 3 && (
            <div className="alert alert-primary" role="alert">
              <b>
                Se solicitó un cambio de fecha/hora para esta sesión y está pendiente de
                confirmación. Recibirá un correo electrónico cuando la sesión esté confirmada por el
                otro asistente.
              </b>{' '}
              <br />
              Si quiere realizar algún cambio o tiene cualquier consulta, por favor, contacte con
              nosotros llamándonos al {phone} o enviándonos un e-mail a {email}{' '}
            </div>
          )}

          {statusWasJustChangedNow === true && (
            <div className="alert alert-info" role="alert">
              <h4>¡Gracias!</h4>
              <b>Se ha almacenado su decisión sobre la sesión.</b>
              <br />
              Si quiere realizar algún cambio o tiene cualquier consulta, por favor, contacte con
              nosotros llamándonos al {phone} o enviándonos un e-mail a {email}{' '}
            </div>
          )}

          {!this.state.showCalendar && !statusWasJustChangedNow && (
            <ConfirmSessionComponent
              otherParticipant={sessionData.attendants.filter(a => a.data.idx !== sessionData.attendant.idx)[0].data}
              scheduledDatetime={moment(scheduledDatetime).tz(proyectoData.gmt).format('LLLL')}
              duration={sessionDuration}
              handleClick={this.handleClick}
            />
          )}

          {this.state.showCalendar && !statusWasJustChangedNow && (
            <RescheduleComponent
              otherParticipant={
                sessionData.attendants.filter(a => a.idx !== sessionData.attendant.idx)[0].data
              }
              scheduledDatetime={moment(scheduledDatetime).tz(proyectoData.gmt).format('LLLL')}
              duration={sessionDuration}
              onChange={newVal => {
                this.setState({ rescheduleSelectedValue: newVal });
              }}
              value={this.state.rescheduleSelectedValue}
              onConfirm={async () => {
                const {
                  match: {
                    params: { sessionId, token },
                  },
                } = this.props;
                const rescheduleSessionRequest = await apiPost(`rescheduleSession`, {
                  sessionId,
                  token,
                  ts: this.state.rescheduleSelectedValue.getTime(),
                });

                if (rescheduleSessionRequest === true) {
                  this.setState(st => ({
                    ...st,
                    showCalendar: false,
                    statusWasJustChangedNow: true,
                    rescheduleSelectedValue: null,
                    sessionData: { ...st.sessionData, status: DECISSION_RESCHEDULE },
                    proyectoData: { ...st.proyectoData, status: DECISSION_RESCHEDULE },
                  }));
                } else {
                  alert(
                    'Error interno tratando de cambiar estado de la sesión. Por favor contacte con soporte si el problema persiste.'
                  );
                }
              }}
              onCancel={() => {
                this.setState({ showCalendar: false });
              }}
            />
          )}

          {this.state.mainScreenMessage && (
            <div id="mainScreenMessage">{this.state.mainScreenMessage}</div>
          )}
        </div>
      </div>
    );
  }
}

export default SessionChangeStatus;
